import service from "@/api/service";
import { FollowUserCSVGetRequest } from "@/api/analysis/follow-user-csv/request";
import { DownloadCSVResponse } from "@/api/response";

/**
 * フォローユーザーCSV出力APIをコールします。
 *
 * @param getRequest フォローユーザーCSV出力APIのリクエストボディ
 * @return response
 */
export async function get(getRequest: FollowUserCSVGetRequest) {
  const response = await service.postReceiveCSV(
    "/analysis-follow-user-csv",
    getRequest
  );
  return response as DownloadCSVResponse;
}
